export enum ScreenWidthEnum {
  MEDIUM = 1280,
  SMALL = 940
}
